import { DataTypeCoaching } from '@efdigital/ll-addon-data/data-types';
import type { CoachingConfig } from '@efdigital/ll-addon-data/types/coaching/coaching-config';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import type { FindRecordOptions } from '@warp-drive/core/types/request';
import {
  deleteRecord,
  findRecord,
  query,
} from '@warp-drive/utilities/json-api';

export function findAllCoachingConfigs() {
  return query<CoachingConfig>(
    DataTypeCoaching.CoachingConfig,
    {},
    jsonApiOptions
  );
}

export function findCoachingConfig(id: string) {
  return findRecord<CoachingConfig>(
    DataTypeCoaching.CoachingConfig,
    id,
    jsonApiOptions as FindRecordOptions
  );
}

export function deleteCoachingConfig(config: CoachingConfig) {
  return deleteRecord(config, jsonApiOptions);
}
